// Маппинг расширений файлов к иконкам
const fileIconMap = {
  pdf: require('../assets/icons/pdf.png'),
  doc: require('../assets/icons/word.png'),
  docx: require('../assets/icons/word.png'),
  xls: require('../assets/icons/excel.png'),
  xlsx: require('../assets/icons/excel.png'),
  jpg: require('../assets/icons/photo.png'),
  jpeg: require('../assets/icons/photo.png'),
  png: require('../assets/icons/photo.png'),
  gif: require('../assets/icons/photo.png'),
  bmp: require('../assets/icons/photo.png'),
  rar: require('../assets/icons/rar.png'),
  zip: require('../assets/icons/rar.png'),
  default: require('../assets/icons/photo.png'),
};

export default fileIconMap;
